import { Button, ButtonColor, ButtonVariant, Input, Select } from "@swivl-mono/ui";
import { useEffect, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";

import LocationsModel from "../../../Models/Locations/Locations.Model";
import ModalModel from "../../../Models/Modal/Modal.Model";

interface Props {
  type: "location" | "group";
  navigate: NavigateFunction;
}
export function AddLocationOrGroupModal(props: Props) {
  const { navigate } = props;
  const { groups } = LocationsModel.useState((s) => s);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [groupId, setGroupId] = useState<number | null>(null);
  useEffect(() => {
    if (props.type === "group") {
      setLoading(false);
    }
    if (props.type === "location" && groups && groups.length > 0 && groupId === null) {
      setGroupId(groups[0].id);
      setLoading(false);
    }
  }, [groups]);

  return (
    <div>
      <Input label={props.type === "location" ? "Location Name" : "Group Name"} value={name} onChange={(e) => setName(e.target.value)} />

      {props.type === "location" && (
        <div>
          <Select
            label="Group"
            options={groups?.map((group) => ({ label: group.name, value: String(group.id) }))}
            selectedValues={groupId ? [String(groupId)] : []}
            onChange={(values) => {
              const selectedValue = values[0];
              setGroupId(selectedValue ? parseInt(selectedValue) : null);
            }}
            hasSearchInDropdown
          />
        </div>
      )}

      {error && <div className="text-red-500">{error}</div>}

      <div className="mt-5 flex flex-row justify-end pb-3">
        <Button variant={ButtonVariant.GHOST} loading={loading} onClick={() => ModalModel.hideModal()} className="mr-2">
          Cancel
        </Button>
        <Button
          color={ButtonColor.ORANGE}
          loading={loading}
          onClick={async () => {
            setLoading(true);
            if (props.type === "location" && groupId) {
              LocationsModel.createLocation(name, groupId)
                .then((location) => {
                  ModalModel.hideModal();
                  navigate(`/properties/group/${groupId}/location/${location?.id}/page/details/info`);
                })
                .catch((e) => {
                  setError(e.message);
                  setLoading(false);
                });
            }

            if (props.type === "group") {
              LocationsModel.createGroup(name)
                .then(() => {
                  navigate(`/properties/group/${groupId}/page/details/info`);
                  ModalModel.hideModal();
                })
                .catch((e) => {
                  setError(e.message);
                  setLoading(false);
                });
            }

            setLoading(false);
          }}
        >
          Create
        </Button>
      </div>
    </div>
  );
}
